import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TerminalDetailsDto } from '../../../models/terminals/terminalDetailsDto';
import { DateUtils } from '../../../helpers/dateUtils';

interface CaseIntegrityHistoryCardProps {
  terminal?: TerminalDetailsDto;
}

export const CaseIntegrityHistoryCard: React.FC<CaseIntegrityHistoryCardProps> = ({ terminal }) => (
  <Box className="gbr" px={2} pb={2} sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Typography variant="h5" fontWeight="bold" sx={{ pt: 2, pb: 1 }}>
      История изменений состояния
    </Typography>
    <TableContainer
      sx={{
        // 4 строки + заголовок таблицы
        maxHeight: 200,
        overflowY: 'auto',
        overflowX: 'hidden',
        borderRadius: '10px',
        border: '1px solid #e0e0e0'
      }}
    >
      <Table
        size="small"
        stickyHeader
        sx={{
          width: '100%',
          tableLayout: 'fixed',
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, fontSize: '14px' }}>Время</TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: '14px' }}>Статус</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {terminal?.events.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{DateUtils.formatDateTime(row.timestamp)}</TableCell>
              <TableCell>{row.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);
